(function () {
  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function trimValue(value) {
    return String(value || '').trim();
  }

  function safeParseJson(value, fallback) {
    if (!value) return fallback;

    try {
      const parsed = JSON.parse(value);
      if (typeof parsed === 'string') {
        try {
          return JSON.parse(parsed);
        } catch (_error) {
          return fallback;
        }
      }
      return parsed;
    } catch (_error) {
      return fallback;
    }
  }

  function findProductJsonScript() {
    const script = document.querySelector('script[type="application/json"][data-product-json]');
    if (!script) return null;
    return safeParseJson(script.textContent, null);
  }

  function findProductJsonFallbackFromScripts() {
    const scripts = Array.from(document.querySelectorAll('script[type="application/json"]'));
    for (const script of scripts) {
      const parsed = safeParseJson(script.textContent, null);
      if (
        parsed &&
        typeof parsed === 'object' &&
        Array.isArray(parsed.variants) &&
        (Array.isArray(parsed.options) || Array.isArray(parsed.options_with_values))
      ) {
        return parsed;
      }
    }
    return null;
  }

  function findProductJsonFallbackFromWindow() {
    const candidates = [
      window.product,
      window.productJson,
      window.__product,
      window.__PRODUCT__,
      window.Shopify && window.Shopify.product,
      window.Theme && window.Theme.product,
      window.meta && window.meta.product,
    ];

    for (const candidate of candidates) {
      if (
        candidate &&
        typeof candidate === 'object' &&
        Array.isArray(candidate.variants) &&
        (Array.isArray(candidate.options) || Array.isArray(candidate.options_with_values))
      ) {
        return candidate;
      }
    }

    return null;
  }

  function resolveProductJson() {
    return findProductJsonScript() || findProductJsonFallbackFromScripts() || findProductJsonFallbackFromWindow();
  }

  function readOptionNames(productJson) {
    if (Array.isArray(productJson.options) && productJson.options.length) return productJson.options;
    if (Array.isArray(productJson.options_with_values)) {
      return productJson.options_with_values.map(function (item) {
        return item && item.name ? item.name : '';
      });
    }
    return [];
  }

  function getOptionIndex(optionNames, targetName) {
    const target = normalize(targetName);
    return optionNames.findIndex(function (name) {
      return normalize(name) === target;
    });
  }

  function extractLabelText(fieldset) {
    const legend = fieldset.querySelector('legend');
    if (legend) {
      const clone = legend.cloneNode(true);
      clone.querySelectorAll('.variant-option__swatch-value').forEach(function (node) {
        node.remove();
      });
      return clone.textContent || '';
    }

    return (
      fieldset.getAttribute('data-option-name') ||
      fieldset.getAttribute('data-name') ||
      fieldset.getAttribute('aria-label') ||
      ''
    );
  }

  function findOptionControl(form, optionName) {
    const normalizedTarget = normalize(optionName);
    if (!normalizedTarget) return null;

    const fieldsets = Array.from(form.querySelectorAll('fieldset'));
    for (const fieldset of fieldsets) {
      const label = extractLabelText(fieldset);
      if (normalize(label) !== normalizedTarget) continue;
      const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      if (!radios.length) continue;

      return {
        type: 'radio',
        elements: radios,
        getValues: function () {
          return radios.map(function (radio) {
            return trimValue(radio.value);
          });
        },
        getValue: function () {
          const checked = radios.find(function (radio) {
            return radio.checked;
          });
          return checked ? trimValue(checked.value) : '';
        },
        setValue: function (value) {
          const cleanValue = trimValue(value);
          const match = radios.find(function (radio) {
            return trimValue(radio.value) === cleanValue;
          });
          if (!match || match.disabled) return false;
          if (!match.checked) match.checked = true;
          match.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        },
      };
    }

    const selects = Array.from(form.querySelectorAll('select'));
    for (const select of selects) {
      const selectName = select.getAttribute('name') || '';
      const dataOptionName = select.getAttribute('data-option-name') || '';
      const matchesByName = normalize(dataOptionName) === normalizedTarget;
      const matchesBySelectName = normalize(selectName.replace(/^options\[|\]$/g, '')) === normalizedTarget;
      if (!matchesByName && !matchesBySelectName) continue;

      return {
        type: 'select',
        elements: [select],
        getValues: function () {
          return Array.from(select.options).map(function (option) {
            return trimValue(option.value);
          });
        },
        getValue: function () {
          return trimValue(select.value);
        },
        setValue: function (value) {
          const cleanValue = trimValue(value);
          const match = Array.from(select.options).find(function (option) {
            return trimValue(option.value) === cleanValue;
          });
          if (!match) return false;
          select.value = match.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        },
      };
    }

    return null;
  }

  function assetUrl(fileName, assetsBase) {
    if (!fileName) return '';
    if (/^(https?:)?\/\//i.test(fileName) || fileName.charAt(0) === '/') return fileName;

    const base = assetsBase || '/assets/';
    const normalizedBase = base.endsWith('/') ? base : base + '/';
    return normalizedBase + encodeURIComponent(fileName).replace(/%2F/g, '/');
  }

  function createGroup(groupType, titleText, values) {
    const group = document.createElement('div');
    group.className = 'swatch-group';
    group.dataset.group = groupType;

    const title = document.createElement('p');
    title.className = 'swatch-title';
    title.innerHTML = titleText + ': <span></span>';
    group.appendChild(title);

    const grid = document.createElement('div');
    grid.className = 'swatch-grid';
    values.forEach(function (value) {
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'swatch-item';
      item.dataset.value = value;
      grid.appendChild(item);
    });

    group.appendChild(grid);
    return group;
  }

  function normalizeTrimMap(rawMap) {
    const direct = {};
    const normalized = {};

    if (!rawMap || typeof rawMap !== 'object') {
      return { direct: direct, normalized: normalized };
    }

    Object.keys(rawMap).forEach(function (key) {
      const cleanKey = trimValue(key);
      const value = trimValue(rawMap[key]);
      if (!cleanKey) return;
      direct[cleanKey] = value;
      normalized[normalize(cleanKey)] = value;
    });

    return { direct: direct, normalized: normalized };
  }

  function resolveTrimColor(trimMaps, value) {
    const cleanValue = trimValue(value);
    if (!cleanValue) return '';
    return trimMaps.direct[cleanValue] || trimMaps.normalized[normalize(cleanValue)] || '';
  }

  function createCarpetFileResolver(carpetMap) {
    return function resolveCarpetFile(cellsValue, carpetValue) {
      const cleanCells = trimValue(cellsValue);
      const cleanCarpet = trimValue(carpetValue);
      const cellMap = carpetMap && typeof carpetMap === 'object' ? carpetMap[cleanCells] : null;
      if (!cellMap || typeof cellMap !== 'object') return '';

      if (cleanCarpet && cellMap[cleanCarpet]) return cellMap[cleanCarpet];

      const first = Object.values(cellMap)[0];
      return typeof first === 'string' ? first : '';
    };
  }

  function resolveCellsSwatchFile(cellsValue) {
    const key = trimValue(cellsValue);
    const map = {
      Romby: 'swatch-typ-komorek-romby.png',
      'Plastry miodu': 'swatch-typ-komorek-plastry-miodu.png',
      Krople: 'swatch-typ-komorek-krople.png',
    };

    return map[key] || '';
  }

  function initRoot(root) {
    if (!(root instanceof HTMLElement)) return;

    const form =
      root.closest('form') ||
      document.querySelector('variant-picker form') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const productJson = resolveProductJson();
    if (!productJson || !Array.isArray(productJson.variants)) return;

    const optionNameCells = root.dataset.optionNameCells || 'Typ kom\\u00f3rek';
    const optionNameCarpet = root.dataset.optionNameCarpet || 'Kolor dywanika';
    const optionNameTrim = root.dataset.optionNameTrim || 'Kolor obszycia';
    const assetsBase = root.dataset.assetsBase || '/assets/';

    const optionNames = readOptionNames(productJson);
    const indexCells = getOptionIndex(optionNames, optionNameCells);
    const indexCarpet = getOptionIndex(optionNames, optionNameCarpet);
    const indexTrim = getOptionIndex(optionNames, optionNameTrim);

    const controlCells = indexCells > -1 ? findOptionControl(form, optionNameCells) : null;
    const controlCarpet = indexCarpet > -1 ? findOptionControl(form, optionNameCarpet) : null;
    const controlTrim = indexTrim > -1 ? findOptionControl(form, optionNameTrim) : null;
    if (!controlCells && !controlCarpet && !controlTrim) return;

    if (typeof root.__swatchCleanup === 'function') {
      root.__swatchCleanup();
    }

    const trimMaps = normalizeTrimMap(safeParseJson(root.dataset.trimMap, {}));
    const carpetMap = safeParseJson(root.dataset.carpetMap, {});
    const resolveCarpetFile = createCarpetFileResolver(carpetMap);

    root.innerHTML = '';
    const groups = {};

    if (controlCells) {
      const values = Array.from(new Set(controlCells.getValues()));
      groups.cells = createGroup('cells', 'Typ kom\u00f3rek', values);
      root.appendChild(groups.cells);
    }

    if (controlCarpet) {
      const values = Array.from(new Set(controlCarpet.getValues()));
      groups.carpet = createGroup('carpet', 'Kolor dywanika', values);
      root.appendChild(groups.carpet);
    }

    if (controlTrim) {
      const values = Array.from(new Set(controlTrim.getValues()));
      groups.trim = createGroup('trim', 'Kolor obszycia', values);
      root.appendChild(groups.trim);
    }

    function getState() {
      return {
        cells: controlCells ? controlCells.getValue() : '',
        carpet: controlCarpet ? controlCarpet.getValue() : '',
        trim: controlTrim ? controlTrim.getValue() : '',
      };
    }

    function isCandidateAvailable(kind, candidateValue, state) {
      const candidate = trimValue(candidateValue);

      return productJson.variants.some(function (variant) {
        if (!variant || variant.available !== true || !Array.isArray(variant.options)) return false;

        if (kind === 'cells') {
          if (indexCells > -1 && trimValue(variant.options[indexCells]) !== candidate) return false;
          if (indexCarpet > -1 && state.carpet && trimValue(variant.options[indexCarpet]) !== state.carpet) return false;
          if (indexTrim > -1 && state.trim && trimValue(variant.options[indexTrim]) !== state.trim) return false;
          return true;
        }

        if (kind === 'carpet') {
          if (indexCarpet > -1 && trimValue(variant.options[indexCarpet]) !== candidate) return false;
          if (indexCells > -1 && state.cells && trimValue(variant.options[indexCells]) !== state.cells) return false;
          if (indexTrim > -1 && state.trim && trimValue(variant.options[indexTrim]) !== state.trim) return false;
          return true;
        }

        if (kind === 'trim') {
          if (indexTrim > -1 && trimValue(variant.options[indexTrim]) !== candidate) return false;
          if (indexCells > -1 && state.cells && trimValue(variant.options[indexCells]) !== state.cells) return false;
          if (indexCarpet > -1 && state.carpet && trimValue(variant.options[indexCarpet]) !== state.carpet) return false;
          return true;
        }

        return false;
      });
    }

    function updateTitles(state) {
      if (groups.cells) {
        const node = groups.cells.querySelector('.swatch-title span');
        if (node) node.textContent = state.cells || '';
      }
      if (groups.carpet) {
        const node = groups.carpet.querySelector('.swatch-title span');
        if (node) node.textContent = state.carpet || '';
      }
      if (groups.trim) {
        const node = groups.trim.querySelector('.swatch-title span');
        if (node) node.textContent = state.trim || '';
      }
    }

    function styleCellsSwatches(state) {
      if (!groups.cells) return;

      groups.cells.querySelectorAll('.swatch-item').forEach(function (swatch) {
        const value = trimValue(swatch.dataset.value);
        const fileName = resolveCellsSwatchFile(value) || resolveCarpetFile(value, state.carpet);
        const url = assetUrl(fileName, assetsBase);

        swatch.dataset.type = 'image';
        swatch.style.backgroundImage = url ? 'url("' + url + '")' : '';
        swatch.style.backgroundColor = url ? '' : '#d9d9d9';
      });
    }

    function styleCarpetSwatches(state) {
      if (!groups.carpet) return;

      groups.carpet.querySelectorAll('.swatch-item').forEach(function (swatch) {
        const value = trimValue(swatch.dataset.value);
        const fileName = resolveCarpetFile(state.cells, value);
        const url = assetUrl(fileName, assetsBase);

        swatch.dataset.type = 'image';
        swatch.style.backgroundImage = url ? 'url("' + url + '")' : '';
        swatch.style.backgroundColor = url ? '' : '#d9d9d9';
      });
    }

    function styleTrimSwatches() {
      if (!groups.trim) return;

      groups.trim.querySelectorAll('.swatch-item').forEach(function (swatch) {
        const value = trimValue(swatch.dataset.value);
        const hex = resolveTrimColor(trimMaps, value);

        swatch.dataset.type = 'color';
        swatch.style.backgroundImage = '';
        swatch.style.backgroundColor = hex || '#d9d9d9';
      });
    }

    function updateSelectionAndDisabled(state) {
      if (groups.cells) {
        groups.cells.querySelectorAll('.swatch-item').forEach(function (swatch) {
          const value = trimValue(swatch.dataset.value);
          const disabled = !isCandidateAvailable('cells', value, state);
          const isSelected = value === state.cells;
          swatch.classList.toggle('is-selected', isSelected);
          swatch.classList.toggle('is-disabled', disabled);
          swatch.setAttribute('aria-disabled', disabled ? 'true' : 'false');
          swatch.hidden = disabled && !isSelected;
        });
      }

      if (groups.carpet) {
        groups.carpet.querySelectorAll('.swatch-item').forEach(function (swatch) {
          const value = trimValue(swatch.dataset.value);
          const disabled = !isCandidateAvailable('carpet', value, state);
          const isSelected = value === state.carpet;
          swatch.classList.toggle('is-selected', isSelected);
          swatch.classList.toggle('is-disabled', disabled);
          swatch.setAttribute('aria-disabled', disabled ? 'true' : 'false');
          swatch.hidden = disabled && !isSelected;
        });
      }

      if (groups.trim) {
        groups.trim.querySelectorAll('.swatch-item').forEach(function (swatch) {
          const value = trimValue(swatch.dataset.value);
          const disabled = !isCandidateAvailable('trim', value, state);
          const isSelected = value === state.trim;
          swatch.classList.toggle('is-selected', isSelected);
          swatch.classList.toggle('is-disabled', disabled);
          swatch.setAttribute('aria-disabled', disabled ? 'true' : 'false');
          swatch.hidden = disabled && !isSelected;
        });
      }
    }

    function render() {
      const state = getState();
      updateTitles(state);
      styleCellsSwatches(state);
      styleCarpetSwatches(state);
      styleTrimSwatches();
      updateSelectionAndDisabled(state);
    }

    function handleClick(event) {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      const swatch = target.closest('.swatch-item');
      if (!(swatch instanceof HTMLElement)) return;
      if (swatch.classList.contains('is-disabled')) return;

      const group = swatch.closest('.swatch-group');
      if (!(group instanceof HTMLElement)) return;

      const value = trimValue(swatch.dataset.value);
      if (!value) return;

      if (group.dataset.group === 'cells' && controlCells) {
        controlCells.setValue(value);
      } else if (group.dataset.group === 'carpet' && controlCarpet) {
        controlCarpet.setValue(value);
      } else if (group.dataset.group === 'trim' && controlTrim) {
        controlTrim.setValue(value);
      }
    }

    root.addEventListener('click', handleClick);

    const cleanupHandlers = [];
    [controlCells, controlCarpet, controlTrim]
      .filter(Boolean)
      .forEach(function (control) {
        control.elements.forEach(function (element) {
          element.addEventListener('change', render);
          cleanupHandlers.push(function () {
            element.removeEventListener('change', render);
          });
        });
      });

    render();

    root.__swatchCleanup = function () {
      root.removeEventListener('click', handleClick);
      cleanupHandlers.forEach(function (cleanup) {
        cleanup();
      });
      root.__swatchCleanup = null;
    };
  }

  function initAll(container) {
    const scope = container instanceof Element ? container : document;
    scope.querySelectorAll('[data-swatch-picker]').forEach(function (root) {
      initRoot(root);
    });
    if (scope instanceof Element && scope.matches('[data-swatch-picker]')) {
      initRoot(scope);
    }
  }

  function observeReRenders() {
    if (!document.body) return;

    const observer = new MutationObserver(function (mutations) {
      const candidates = new Set();

      mutations.forEach(function (mutation) {
        if (mutation.target instanceof Element && mutation.target.matches('[data-swatch-picker]')) {
          const hasGroups = mutation.target.querySelector('.swatch-group');
          if (!hasGroups) {
            candidates.add(mutation.target);
          }
        }

        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.matches('[data-swatch-picker]')) {
            candidates.add(node);
          }
          node.querySelectorAll('[data-swatch-picker]').forEach(function (root) {
            candidates.add(root);
          });
        });
      });

      candidates.forEach(function (root) {
        initRoot(root);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
      observeReRenders();
    });
  } else {
    initAll(document);
    observeReRenders();
  }
})();

